/* ToolbarButtonGroup.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./ToolbarButtonGroup.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Children, Fragment } from 'react';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  container: "_1e0c1txw",
  firstChild: "_fb2512x7 _t1diidpf _u6eridpf",
  lastChild: "_fb2512x7 _xk07idpf _1jiyidpf",
  firstChildNew: "_19pe12x7 _1qq0idpf _3nesidpf",
  lastChildNew: "_19pe12x7 _15rdidpf _i84vidpf"
};
export var ToolbarButtonGroup = function ToolbarButtonGroup(_ref) {
  var children = _ref.children;
  var items = Children.toArray(children);
  var FirstChild = items.at(0);
  var LastChild = items.at(-1);
  var middleChildren = items.slice(1, -1);
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.container,
    "data-toolbar-component": "button-group"
  }, items.length <= 1 ? children : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: ax([styles.firstChildNew])
  }, FirstChild), middleChildren, /*#__PURE__*/React.createElement("div", {
    className: ax([styles.lastChildNew])
  }, LastChild)));
};